export default __webpack_public_path__ + "b00fb8539cfdda7c1b18eb7b66bc8f66.png";